/**
 * Joriy subdomen (tenant slug) — brend/login uchun. Hozircha majburiy emas:
 * ma'lumot izolyatsiyasi serverda foydalanuvchi tenant'i bo'yicha bo'ladi.
 * `VITE_TENANT_BASE_DOMAIN` o'rnatilsa subdomen ajratiladi (masalan "maktab.uz").
 */
const BASE = import.meta.env.VITE_TENANT_BASE_DOMAIN as string | undefined;
/** Zaxiralangan subdomenlar — backend `lib/tenant.ts` → RESERVED_SLUGS bilan BIR XIL. */
const RESERVED = new Set(['www', 'admin', 'app', 'api', 'localhost']);

/** DNS yorlig'i chegarasi (backend `SLUG_MAX`). */
export const SLUG_MAX = 63;

/**
 * Maktab slugi (subdomen) xatosi — yaratish VA tahrirlash formalari uchun bitta qoida
 * (backend `normalizeSlug` ning qat'iy ko'rinishi: front belgilarni jimgina olib
 * tashlamaydi, balki ko'rsatadi). `null` — yaroqli. Qaytgan kalit `tenantsPage.*`.
 */
/**
 * Eski shartnoma rekvizitlari zaxirasi bog'langan slug (backend `lib/contract.ts` →
 * LEGACY_REQUISITES_SLUG). Undan ketayotgan maktabning rekvizitlari server tomonida
 * avtomatik saqlanadi — UI buni ogohlantirishda aytadi.
 */
export const LEGACY_REQUISITES_SLUG = 'sata';

/** Shartnoma raqami prefiksi — backend `contractNumberPrefix` bilan bir xil (`sata` → `SATA`). */
export function contractNumberPrefix(slug?: string | null): string {
  return (slug ?? '').toUpperCase().replace(/[^A-Z0-9]/g, '') || 'SCH';
}

export function slugError(v: string): string | null {
  if (!/^[a-z0-9-]+$/.test(v)) return 'slugInvalid';
  if (v.length > SLUG_MAX) return 'slugTooLong';
  if (v.startsWith('-') || v.endsWith('-')) return 'slugEdgeDash';
  if (RESERVED.has(v)) return 'slugReserved';
  return null;
}

export function currentSubdomain(): string | null {
  if (!BASE) return null;
  const host = window.location.hostname.toLowerCase();
  if (!host.endsWith(`.${BASE}`)) return null;
  const first = host.slice(0, -(BASE.length + 1)).split('.')[0];
  return first && !RESERVED.has(first) ? first : null;
}

export const tenantBaseDomain = (): string | undefined => BASE;

/**
 * Foydalanuvchini o'z maktabi subdomeniga (superadmin — apex'ga) YUMSHOQ yo'naltiradi.
 * Faqat asosiy domen ostida ishlaydi — localhost/railway'da inert (hech narsa qilmaydi).
 * Ma'lumot baribir token bilan izolyatsiya qilingan; bu faqat URL/brend to'g'riligi uchun.
 */
export function tenantRedirect(user: { tenantSlug?: string | null } | null | undefined): void {
  if (!BASE || !user) return;
  const host = window.location.hostname.toLowerCase();
  if (host !== BASE && !host.endsWith(`.${BASE}`)) return; // asosiy domen ostida emas
  const expected = user.tenantSlug ? `${user.tenantSlug}.${BASE}` : BASE; // superadmin → apex
  if (host !== expected) {
    window.location.href = `${window.location.protocol}//${expected}${window.location.pathname}${window.location.search}`;
  }
}
